import React, { useEffect, useRef } from "react";
import "./header.css";
import CTA from "./CTA";
import header_picture from "../../assets/header-picture2.png";
import HeaderSocials from "./HeaderSocials";
import Typed from "typed.js";

const Header = () => {
  const typedElement = useRef(null);

  useEffect(() => {
    const typed = new Typed(typedElement.current, {
      strings: [
        "Programmer",
        "Web Developer",
        "AIML Enthusiast",
        "Data Analyst",
        "Aspiring Data Scientist"
      ],
      typeSpeed: 150,
      backSpeed: 150,
      loop: true
    });

    return () => {
      typed.destroy(); // Clean up on unmount
    };
  }, []);

  return (
    <header>
      <div className="container header__container">
        <h5 className="dx">Hello This is</h5>
        <h1 className="ad">Sai Sriram Kamineni</h1>

        {/* Static "I am" followed by dynamic text */}
        <h5 className="e">I'm</h5>
        <h2><span className="dynamic-text" ref={typedElement}></span>
        </h2>
        <CTA />
        <HeaderSocials />
        <div className="Ram">
          <img src={header_picture} alt="Sai Sriram Kamineni" />
        </div>
        <a href="#contact" className="scroll__down">
          Scroll Down
        </a>
      </div>
    </header>
  );
};

export default Header;
